import httpManager from "../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchContact(id) {
  const url = `/contacts/clients/${id}`;
  const response = await httpManager.get(url);
  return response.data;
}
